document.addEventListener("DOMContentLoaded", (event) => {

  function setVhUnit() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  setVhUnit();
  window.addEventListener('resize', setVhUnit);

  
  document.documentElement.style.setProperty("--top-menu-height", document.querySelector('.shopify-section--header').offsetHeight + 'px');

    /* =======================================================================
  ======== Mega menu show script on mouseover over the top level menu ======= */
  const topLinks = document.querySelectorAll('.top-menu--link');
  const topSimpleLinks = document.querySelectorAll('.top-menu--link:not(.has-children)');
  const megaMenus = document.querySelectorAll('.top-menu--megamenu.sss');
  const megaMenuBoxs = document.querySelectorAll('.top-menu--megmamenu-container');
  
  topLinks.forEach(link => {
    link.addEventListener("mouseover", function() {
      topLinks.forEach(l => l.classList.remove('active'));
      this.classList.add('active');
      let cat = this.getAttribute('href').replace('/collections/', '');
      // Hide all megamenus
      megaMenus.forEach(menu => {
        menu.classList.add('hide');
        // document.querySelector('.top-menu--level-1').classList.remove('open');
      });
  
      // Show the matching megamenu
      const targetMenu = document.querySelector(`.top-menu--megamenu.sss[data-cat="${cat}"]`);
      if (targetMenu) {
        targetMenu.classList.remove('hide');
        // document.querySelector('.top-menu--level-1').classList.add('open');
      }
    });

    link.addEventListener('mouseleave', function(){
      
    });
  });
  
  megaMenus.forEach(menu => {
    menu.addEventListener('mouseleave', function(){
      this.classList.add('hide');
      // document.querySelector('.top-menu--level-1').classList.remove('open');
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });

  megaMenuBoxs.forEach(menuBox => {
    menuBox.addEventListener('mouseleave', function(){
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });

  topSimpleLinks.forEach(link => {
    link.addEventListener('mouseleave', function(){
      topLinks.forEach(link => { link.classList.remove('active'); });
    });
  });
  
  
  /* ========================================
  ======== Mega menu masonry script ======= */
  
  const megamenus = document.querySelectorAll('.top-menu--megmamenu-container.style--1 .megamenu-body');
  if (megamenus) {
    megamenus.forEach(megamenu => {
      var msnry = new Masonry( megamenu, {
        itemSelector: '.megamenu-item-block',
        // columnWidth: 200,
        percentPosition: true,
        // gutter: 20,
        // horizontalOrder: true,
        fitWidth: true
      });
    });    
  }

  window.addEventListener("resize", () => {
    const megamenus = document.querySelectorAll(".top-menu--megmamenu-container.style--1 .megamenu-body");
    
    if (megamenus) {
      megamenus.forEach(megamenu => {
        var msnry = new Masonry(megamenu, {
          itemSelector: ".megamenu-item-block",
          percentPosition: true,
          fitWidth: true
        });
      });
    }
  });


  /* ===============================================================
  ===== Sidebar Menu: Designers initial click to group script ======= */
  
  document.body.addEventListener("click", (e) => {
    const clickedInitial = e.target.closest(".header-sidebar .designers-initial:not(.disabled)");
    if (!clickedInitial) return;
  
    // Toggle active class
    document.querySelectorAll('.header-sidebar .designers-initial.active').forEach(el => {
      el.classList.remove('active');
    });
    clickedInitial.classList.add('active');
  
    // Get to-term string and its parent container
    let termStr = clickedInitial.getAttribute('to-term');
    if (!termStr) return;
  
    const container = clickedInitial.closest('.designers-container');
    if (!container) return;
  
    const scroller = document.querySelector('.header-sidebar__scroller');
    const header = document.querySelector('.shopify-section--header');
    const topMenu = document.querySelector('.shopify-section--top-menu');
    const offset = (header?.offsetHeight || 0) + (topMenu?.offsetHeight || 0) + 50;
  
    // Loop one character at a time
    for (let i = 0; i < termStr.length; i++) {
      const char = termStr[i];
      const targetGroup = container.querySelector(`.designer-list--group[term="${char}"]`);
      if (targetGroup) {
        // Scroll to the first matching group
        if (scroller) {
          scroller.scrollTo({
            top: targetGroup.offsetTop - offset,
            behavior: "smooth"
          });
        }
        break; // Stop after the first found match
      }
    }
  });


  
/* ====================================================
===== Designers initial click to group script ======= */

document.body.addEventListener("click", (e) => {
  const initial = e.target.closest(".shopify-section--designers .designers-initial:not(.disabled)");
  if (!initial) return;

  // Reset active state
  document.querySelectorAll(".shopify-section--designers .designers-initial").forEach(el => {
    el.classList.remove("active");
  });
  initial.classList.add("active");

  const term = initial.getAttribute("to-term");
  const header = document.querySelector(".shopify-section--header");
  const announcement = document.querySelector(".shopify-section--announcement-bar");
  const offset = (header?.offsetHeight || 0) + (announcement?.offsetHeight || 0) + 50;

  // Try to find the target group for this term
  let target_group = document.querySelector(`.shopify-section--designers .designer-list--group[term="${term}"]`);

  // If it doesn't exist, find the next available group
  if (!target_group) {
    const allGroups = Array.from(document.querySelectorAll(".shopify-section--designers .designer-list--group"));
    // Find the first group whose term is alphabetically greater than the clicked term
    target_group = allGroups.find(group => group.getAttribute("term") > term) || allGroups[allGroups.length - 1];
  }

  if (!target_group) return; // Safety guard

  window.scrollTo({
    top: target_group.offsetTop - offset,
    behavior: "smooth"
  });
});


  /* =============================================
  ======= Designers search filter script ======= */
  
  const input = document.getElementById("designer_search");
  const searchSection = document.querySelector("#designers_search_section");
  const items = document.querySelectorAll(".designer-list");
  const groups = document.querySelectorAll(".designer-list--group");
  const cancelButton = document.querySelector("#search_cancel");

  if (input) {
    input.addEventListener("keyup", () => {
      const filter = input.value.trim().toUpperCase();
      searchSection.classList.toggle("active", filter !== "");

      items.forEach(item => {
          const txtValue = item.textContent.trim() || item.innerText.trim();
          item.classList.toggle("hidden", !txtValue.toUpperCase().includes(filter));
      });

      groups.forEach(group => {
          const term = group.getAttribute("term");
          const hasVisibleItems = group.querySelector(".designer-list:not(.hidden)");

          group.classList.toggle("hidden", !hasVisibleItems);
          document.querySelector(`.designers-initials .designers-initial[to-term="${term}"]`)
              .classList.toggle("disabled", !hasVisibleItems);
      });
    });
  }

  if (cancelButton) {
    cancelButton.addEventListener("click", () => {
      input.value = "";
      input.dispatchEvent(new KeyboardEvent("keyup", { key: "Enter", keyCode: 13, bubbles: true }));

      document.querySelectorAll(".designers-initial").forEach(initial => {
          initial.classList.remove("active");
      });
    });
  }

    /* =============================================
  ======= Mobile menu featured collection image update ======= */

  const mobileBtns = document.querySelectorAll('.header-sidebar-head .header-sidebar__linklist-button');
  const featuredCols = document.querySelectorAll('.featured-collections-section .featured-collections-list');
  
  if (mobileBtns.length > 0) {
    mobileBtns.forEach(mobileBtn => {
      mobileBtn.addEventListener('click', () => {
        let menuType = mobileBtn.getAttribute('menu-type');
        featuredCols.forEach(featuredCol => featuredCol.classList.remove('active'));
        document.querySelector(`.featured-collections-section .featured-collections-list[menu-type="${menuType}"]`)?.classList.add('active');
      });
    });
  }

  /* =============================================
  ======= Mobile menu Contact trigger ======= */
  
  document.querySelector('#footer_contact_triger')?.addEventListener('click', function (e) {
    e.preventDefault();
    const parent = this.closest('.header-sidebar__footer');
    if (parent) {
      const talkBox = parent.querySelector('.header-sidebar__footer.talk-human');
      if (talkBox) {
        talkBox.classList.toggle('open');
      }
    }
  });

  /* =============================================
  ======= Mobile menu Top Level accordion action ======= */

  const _mobileTopLinks = document.querySelectorAll('.header-sidebar__scroller .top-level-menu');
  _mobileTopLinks.forEach(_toplink => {
    _toplink.addEventListener('click', function () {
      const isActive = this.classList.contains('active');
  
      _mobileTopLinks.forEach(link => link.classList.remove('active'));
      document.querySelector('.header-sidebar__scroller').classList.remove('active');
  
      if (!isActive) {
        this.classList.add('active');
        document.querySelector('.header-sidebar__scroller').classList.add('active');
      }
      
    });
  });

  const _mobileSubLinks = document.querySelectorAll('.header-sidebar__scroller>ul[data-level="1"] button');
  _mobileSubLinks.forEach(_mobileSubLink => {
    _mobileSubLink.addEventListener('click', function () {
      _mobileTopLinks.forEach(link => link.classList.add('hidden'));
    });
  });  

  const _backBtns = document.querySelectorAll('.back-parent[data-target*="main-panel-1-"]');
  _backBtns.forEach(_backBtn => {
    _backBtn.addEventListener('click', function () {
      _mobileTopLinks.forEach(link => link.classList.remove('hidden'));
    });
  });

  /* =============================================
  ======= Hero slideshow scrolldown next button action  ======= */

  document.querySelectorAll('.slideshow__next-section-button').forEach(sectionNextBtn => {
    sectionNextBtn.addEventListener('click', () => {
      const parentSection = sectionNextBtn.closest('.shopify-section');
  
      // Find next visible .shopify-section that doesn't have .smi-styles
      let targetSection = parentSection.nextElementSibling;
      while (targetSection && (targetSection.classList.contains('smi-styles') || !targetSection.classList.contains('shopify-section'))) {
        targetSection = targetSection.nextElementSibling;
      }
  
      if (targetSection) {
        const header1 = document.querySelector('.shopify-section--header');
        const header2 = document.querySelector('.shopify-section--top-menu');
        const headerHeight = (header1?.offsetHeight || 0) + (header2?.offsetHeight || 0);
  
        const scrollTargetY = targetSection.getBoundingClientRect().top + window.scrollY - headerHeight;
  
        window.scrollTo({
          top: scrollTargetY,
          behavior: 'smooth'
        });
      }
    });
  });

  /* =========== PDP media gallery update =============== */
  
  document.body.classList.contains("page-product")?document.body.classList.add("gallery-active"):null; 
/*
  function updateGalleryMode(){

    const scrollTop = window.scrollY;
    const infoTop = document.querySelector("safe-sticky.product-info").offsetTop;

    if(scrollTop < 20){

      document.body.classList.add("gallery-active");

    }else{

      document.body.classList.remove("gallery-active");

    }

  }

  window.addEventListener("scroll", updateGalleryMode);

  updateGalleryMode();
*/
  let galleryInitialized = false;

  function initProductGallery() {

    //if(galleryInitialized) return;
    //galleryInitialized = true;

    document.body.classList.contains("page-product")?document.body.classList.add("gallery-active"):null;   
    const carousel = document.querySelector(".shopify-section--main-product scroll-carousel");
    const carousel_items = carousel.querySelectorAll(".product-gallery__media");
    const carousel_dots = document.querySelectorAll(".shopify-section--main-product .scroll-marker");

    // CLICK → Scroll to item
    carousel_dots.forEach((dot, index) => {      
      dot.addEventListener("click", function () {
        carousel_items[index].scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });

    // SCROLL → Update active dot
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = [...carousel_items].indexOf(entry.target);

            carousel_dots.forEach((d) => d.setAttribute("aria-current", "false"));
            if (carousel_dots[index]) {
              carousel_dots[index].setAttribute("aria-current", "true");
            }
          }
        });
      },
      {
        root: window.innerWidth < 100 ? carousel : null, 
        threshold: 0.6
      }
    );

    carousel_items.forEach((item) => {
      observer.observe(item);
      item.querySelector('img')?.addEventListener('click',function(){
        this.nextElementSibling.click();
      })
    }); 

    /*
    const info_swap_btn = document.querySelector(".drag-handle-container");
    const pd_gallery = document.querySelector(".product>product-gallery");
    const pd_info = document.querySelector("safe-sticky.product-info");
    
    pd_info.setAttribute('id','pdp-info')

    let galleryMode = true;
     
    info_swap_btn?.addEventListener("click", function(){

      if(!galleryMode){

        document.querySelector(".product>product-gallery").scrollIntoView({
          behavior:"smooth",
          block: "start"
        });

        //document.body.classList.add("gallery-active");    

      } else {

        document.querySelector("safe-sticky.product-info").scrollIntoView({
          behavior:"smooth",
          block: "start"
        });

        //document.body.classList.remove("gallery-active");    

      }

      galleryMode = !galleryMode;

    });  
    
    const galleryList = document.querySelector(
      ".shopify-section--main-product .product-gallery__image-list"
    );

    let autoScrolling = false;

    galleryList?.addEventListener("scroll", function () {

      if(autoScrolling) return;

      const scrollBottom =
        galleryList.scrollTop + galleryList.clientHeight;

      const maxScroll = galleryList.scrollHeight;

      // detect when user reaches bottom
      if (scrollBottom >= maxScroll - 5 ) {

        autoScrolling = true;

        pd_info.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        setTimeout(()=>{
          autoScrolling = false;
        },400);

        //document.body.classList.remove("gallery-active");  
      }
    });
    */ 

    /* mobile only */
    if (!window.matchMedia("(max-width: 749px)").matches) return;
    if (!document.body.classList.contains("page-product")) return;

    const body = document.body;
    const gallery = document.querySelector(".product > product-gallery");
    const galleryList = document.querySelector(".product-gallery__image-list");
    const info = document.querySelector("safe-sticky.product-info");
    const swapBtn = document.querySelector(".drag-handle-container");

    if (!gallery || !galleryList || !info) return;

    const GALLERY_HEIGHT = "calc(100svh - 255px)";

    let collapsed = false;
    let lastScrollY = window.scrollY;

    /* ---------- state ---------- */

    function expandGallery() {
      gallery.style.height = GALLERY_HEIGHT;
      body.classList.add("gallery-active");
      collapsed = false;
    }

    function collapseGallery() {
      gallery.style.height = "0px";
      body.classList.remove("gallery-active");
      collapsed = true;
    }

    expandGallery();

    /* ---------- gallery scroll ---------- */

    galleryList.addEventListener("scroll", () => {

      if (collapsed) return;

      const bottom =
        galleryList.scrollTop + galleryList.clientHeight;

      if (bottom >= galleryList.scrollHeight - 5) {
        collapseGallery();
      }

    }, { passive: true });

    /* ---------- page scroll (restore when scrolling up) ---------- */

    window.addEventListener("scroll", () => {

      const currentY = window.scrollY;
      const scrollingUp = currentY < lastScrollY;

      lastScrollY = currentY;

      if (!collapsed || !scrollingUp) return;

      if (info.getBoundingClientRect().top >= -5) {
        expandGallery();
      }

    }, { passive: true });

    /* ---------- swap button ---------- */

    swapBtn?.addEventListener("click", () => {
      collapsed ? expandGallery() : collapseGallery();
    });
  } 

  const productSection = document.querySelector(".shopify-section--main-product");

  const galleryObserver = new MutationObserver(() => {

    if (document.querySelector(".product > product-gallery")) {
      initProductGallery();
    }

  });

  galleryObserver.observe(productSection, {
    childList: true,
    subtree: true
  });

    
});